import { getMediaBasePath } from '@geneo2-web/shared-ui';
import { CloudUpload } from '@protos/learning_management/lms.db_pb';
import { Subject_SubjectEnum } from '@protos/common/common.db_pb';

// =============================================================

// Maps a route/query subject string (e.g. "math", "SCIENCE") to the protobuf
// Subject_SubjectEnum numeric value. Returns undefined when missing or invalid.
export const getSubjectEnumFromStringEnum = (
  subjectParam?: string
): Subject_SubjectEnum | undefined => {
  if (!subjectParam) {
    return undefined;
  }
  const enumValue =
    Subject_SubjectEnum[
      subjectParam.trim().toUpperCase() as keyof typeof Subject_SubjectEnum
    ];

  return typeof enumValue === 'number' ? enumValue : undefined;
};

// =============================================================

// Resolves a CloudUpload to a stable preview URL for <img src>.
// Prefers previewUrl, then gcpFileUrl, then signedUrl; strips query params
// (signed URLs expire) and prefixes with the userDataBucket media base path.
export const getCloudUploadPreviewSrc = (upload?: CloudUpload) => {
  const raw = upload?.previewUrl || upload?.gcpFileUrl || upload?.signedUrl;
  if (!raw) return '';
  const withoutQuery = raw.split('?')[0];
  return getMediaBasePath(withoutQuery, 'userDataBucket');
};

// =============================================================

/** Prefer signed URL (with query) for export fetch fallback when public path fails. */
export const getCloudUploadExportSrc = (upload?: CloudUpload) => {
  const raw = upload?.signedUrl || upload?.gcpFileUrl || upload?.previewUrl;
  return raw?.trim() || '';
};

// =============================================================

// Formats byte count for upload UI labels (e.g. "512 b", "24 kb", "1.2 MB").
export const formatFileSize = (bytes: number) => {
  if (bytes < 1024) return `${bytes} b`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} kb`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

// =============================================================
